import equal from 'deep-is';

export const isEqual = (elementA, elementB) => equal(elementA, elementB);
